export default [
    {
        path: '/signatures/type-process',
        name: 'signatures-type-process',
        component: () => import ('./pages/TypeProcessIndex'),
        meta: {
            title: 'Tipos de processos para assinaturas',
            icon: 'mdi-buffer',
            breadcrumbs: [
                { text: 'Lista de tipos de processos para assinaturas', disabled: true }
            ]
        }
    },
]